<template>
  <div class="contact-page" style="padding-top: 80px">
    <!-- Our Testimonials -->
    <section class="our-testimonials">
      <div>
        <div class="container mx-auto p-12">
          <div class="mb-12 text-center">
            <h2>Contact Us</h2>
          </div>
          <div v-if="!messageSent">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4">
              <div>
                <p class="mb-2">Full Name</p>
                <input type="text" placeholder="Full Name" />
              </div>
              <div>
                <p class="mb-2">Email</p>
                <input type="text" placeholder="Email" />
              </div>
              <div>
                <p class="mb-2">Contact Number</p>
                <input type="text" placeholder="Contact Number" />
              </div>
              <div>
                <p class="mb-2">How did you hear about us?</p>
                <select>
                  <option
                    v-for="(source, index) in sourceOfClient"
                    :key="'propertyTypeSelect' + index"
                  >
                    {{ source }}
                  </option>
                </select>
              </div>
              <div class="md:col-span-2">
                <p class="mb-2">Message</p>
                <textarea
                  name="message"
                  id="message"
                  placeholder="Let us know how we can help"
                  cols="30"
                  rows="10"
                ></textarea>
              </div>
              <div class="md:col-span-2">
                <div class="flex">
                  <p class="flex justify-center items-center px-6 pl-0">
                    <input
                      class="mr-2"
                      type="checkbox"
                      id="termsAndConditions"
                      name="termsAndConditions"
                    />
                    <span
                      >I agree with the Terms & Conditions and Privacy
                      Policy</span
                    >
                  </p>
                </div>
              </div>
            </div>
            <button
              type="submit"
              class="btn btn-primary mt-8"
              @click="messageSent = true"
            >
              Submit
            </button>
          </div>
          <div v-else class="flex items-center justify-center my-16">
            <eva-icon
              name="checkmark-circle-2-outline"
              class="fill-current text-green-700 mr-16"
              width="150"
              height="150"
            />
            <p class="text-xl">
              Thank you for contact us! We will be in touch with you shortly.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      messageSent: false,
      sourceOfClient: [
        "Search engine (Google, Yahoo, etc.)",
        "Recommended by friend or colleague",
        "Facebook",
        "Instagram",
        "LinkedIn",
        "Local sponsorships",
        "Other",
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
input[type="radio"],
input[type="checkbox"] {
  width: 15px;
  height: 15px;
}
</style>
